/*
export function someGetter (state) {
}
*/

export const administracaoCorrente = (state) => {
  return state.administracao
}

export const anoCorrente = (state) => {
  return state.ano
}

export const administracaoAnoCorrente = (state) => {
  return state
}
